import { render, staticRenderFns } from "./logList.vue?vue&type=template&id=72fe3e13&scoped=true"
import script from "./logList.vue?vue&type=script&lang=js"
export * from "./logList.vue?vue&type=script&lang=js"
import style0 from "./logList.vue?vue&type=style&index=0&id=72fe3e13&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72fe3e13",
  null
  
)

export default component.exports